import * as API from './../base/api_service';
import * as serviceCallConfig from './../config/api_urls';

export var QUESTIONNAIRE_DETAILS = 'QUESTIONNAIRE_DETAILS';
export var QUESTIONNAIRE_DATA = 'QUESTIONNAIRE_DATA';
export var QUESTIONNAIRE_DETAILS_FAIL = 'QUESTIONNAIRE_DETAILS_FAIL';


export var ANSERTYPE_DETAILS = 'ANSERTYPE_DETAILS';
export var ANSERTYPE_DATA = 'ANSERTYPE_DATA';
export var ANSERTYPE_DETAILS_FAIL = 'ANSERTYPE_DETAILS_FAIL';

export var CREATE_UNIQUE = 'CREATE_UNIQUE';
export var CREATE_UNIQUE_DATA = 'CREATE_UNIQUE_DATA';
export var CREATE_UNIQUE_FAIL = 'CREATE_UNIQUE_FAIL';

export var QUESTIONS_UPDATE = 'QUESTIONS_UPDATE';
export var QUESTIONS_UPDATE_DATA = 'QUESTIONS_UPDATE_DATA';
export var QUESTIONS_UPDATE_FAIL = 'QUESTIONS_UPDATE_FAIL';

export var DELETED_UNIQUE_QS_DATA = 'DELETED_UNIQUE_QS_DATA';
export var DELETED_UNIQUE_QS_DATA_FAIL = 'DELETED_UNIQUE_QS_DATA_FAIL';

export var ADMIN_UNIQUE_QUESTION_ALL = 'ADMIN_UNIQUE_QUESTION_ALL';
export var GET_ALL_UNIQUE_QS = 'GET_ALL_UNIQUE_QS';

export var EXPRESSION_UPDATE = 'EXPRESSION_UPDATE';

export var WEEKLY_SURVEY_UPDATE = 'WEEKLY_SURVEY_UPDATE';


export var questionnaire = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_GET,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.QUESTIONNAIRE_DETAILS),//endPoint
            '',//payLoad
            serviceCallConfig.QUESTIONNAIRE_DETAILS,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            data,//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};

export var questionnaireData = (data) => ({
    type: QUESTIONNAIRE_DATA,
    data: data
});

export var questionnaireDetailsFail = (data) => {
    return ({
        type: QUESTIONNAIRE_DETAILS_FAIL,
        data: data
    });
};


export var anserType = (data) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_GET,
            dispatch,
            serviceCallConfig.get(serviceCallConfig.ANSERTYPE_DETAILS),
            data,
            serviceCallConfig.ANSERTYPE_DETAILS,
            false,//isURLEncoded
            '',//getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            data,//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey

        );

    };
};

export var answerTypeData = (data) => ({
    type: ANSERTYPE_DATA,
    data: data
});

export var answerFaildDetails = (data) => {
    return ({
        type: ANSERTYPE_DETAILS_FAIL,
        data: data
    });
};

export var createUnique = (data) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_POST,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.CREATE_UNIQUE),//endPoint
            data,//payLoad
            serviceCallConfig.CREATE_UNIQUE,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken, //authKey
            '',//api_key
            '',//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );
    };
};

export var createUniqueDate = (data) => ({
    type: CREATE_UNIQUE_DATA,
    data: data
});

export var createUniqueFaildData = (data) => {
    return ({
        type: CREATE_UNIQUE_FAIL,
        data: data
    });
};

export var questionUpdate = (data) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_POST,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.QUESTIONS_UPDATE),//endPoint
            data,//payLoad
            serviceCallConfig.QUESTIONS_UPDATE,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken, //authKey
            '',//api_key
            '',//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};

export var qusUpDateData = (data) => ({
    type: QUESTIONS_UPDATE_DATA,
    data: data
});

export var qusUpdateFail = (data) => {
    return ({
        type: QUESTIONS_UPDATE_FAIL,
        data: data
    });
};


export var deleteUQestions = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_GET,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.DELETEUNIQUEQS),//endPoint
            '',//payLoad
            serviceCallConfig.DELETEUNIQUEQS,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            data,//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};



// export var deleteUQestions = (data) => {
//     return (dispatch, getState) => {
//         API.makeServiceCall(
//             serviceCallConfig.API_GET,
//             dispatch,
//             serviceCallConfig.get(serviceCallConfig.DELETEUNIQUEQS),
//             data,
//             serviceCallConfig.DELETEUNIQUEQS,
//             false

//         );

//     };
// };

export var deleteUniqewQsData = (data) => ({
    type: DELETED_UNIQUE_QS_DATA,
    data: data
});

export var answerFaildDetails = (data) => {
    return ({
        type: DELETED_UNIQUE_QS_DATA_FAIL,
        data: data
    });
};
export var adminGetAllUniqueQuestion = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_GET,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.ADMIN_UNIQUE_QUESTION_ALL),//endPoint
            '',//payLoad
            serviceCallConfig.ADMIN_UNIQUE_QUESTION_ALL,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            data,//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};

export var adminUniqueQuestionAll_data = (data) => ({
    type: GET_ALL_UNIQUE_QS,
    data: data
});

export var adminUniqueQuestionAllFaild_data = (data) => {
    return ({
        type: GET_ALL_UNIQUE_QS,
        data: data
    });
};

// EXPRESSION UPDATE

export var expressionUpdate = (data) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_PUT,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.EXPRESSION_UPDATE),//endPoint
            '',//payLoad
            serviceCallConfig.EXPRESSION_UPDATE,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken, //authKey
            '',//api_key
            data,//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};

export var updateExpression = (data) => ({
    type: EXPRESSION_UPDATE,
    data: data
});

// WEEKLY SURVEY UPDATE

export var weeklySurveyUpdate = (data) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_PUT,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.WEEKLY_SURVEY_UPDATE),//endPoint
            data,//payLoad
            serviceCallConfig.WEEKLY_SURVEY_UPDATE,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken, //authKey
            '',//api_key
            '',//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};

export var surveyWeeklyUpdate = (data) => ({
    type: WEEKLY_SURVEY_UPDATE,
    data: data
}, () => {
    console.log(data);

});


/** WEBPACK FOOTER **
 ** ./src/actions/questionnaire_actions.js
 **/